import React, { Component } from "react";
import TopNav from "../containers/TopNav/TopNav";
import AdvantagesSection from "../containers/AdvantagesSection";
import HowItWorksSection from "../components/HowItWorksSection";
import { Translate } from "react-redux-i18n";

import HomeHero from "../containers/HomeHero";
import Footer from "../containers/Footer";
import SuggestionsList from "../containers/SuggestionsList";
import CirclesInCollectionList from "../containers/CirclesInCollectionList";

import NewCircleCard from "../components/NewCircleCard";
import RequestCircle from "../containers/RequestCircle";
import AppWrapper from "../containers/AppWrapper";

class Collection extends Component {
  render() {
    return (
      <AppWrapper>
        <TopNav />
        <HomeHero />
        <CirclesInCollectionList collection={this.props.match.params.collectionId} />
        <SuggestionsList collection={this.props.match.params.collectionId} />
        <section className="gray-bg">
          <div className="main-container">
            <div className="content-wrapper align-center">
              <h1 className="bp3-heading hero-heading">
                <Translate value="home.havent_found_heading" />
              </h1>
              <div className="flex-top-space-between">
                <NewCircleCard />
                <RequestCircle />
              </div>
            </div>
          </div>
        </section>

        <HowItWorksSection />

        <AdvantagesSection />
        <Footer />
      </AppWrapper>
    );
  }
}

export default Collection;
